import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ICreateComment } from '@/Module/Comment/Model/ApiModel/ICreateComment';
import type { IComment } from '@/Module/Comment/Model/DataModel';
import { CommentService } from '@/Module/Comment/Service';

export const createCommentAction = createAsyncThunk<IComment, ICreateComment>(
  'comment/create',
  async (comment, { signal }) => {
    return CommentService.createComment(comment, signal).then(({ data: { data } }) => {
      return data;
    });
  },
);
